import {
  GET_HOLIDAY_SUCCESS,
  GET_HOLIDAY_FAIL,
  GET_HOLIDAY_DETAILS_SUCCESS,
  GET_HOLIDAY_DETAILS_FAIL,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_FAIL,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAIL,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAIL,
  RESET_HOLIDAY_STATE,
} from "./actionTypes"

const INIT_STATE = {
  holiday: [],
  holidayDetails: [],
  addHoliday: [],
  editHoliday: [],
  delHoliday: [],
  error: [],
}

const Holiday = (state = INIT_STATE, action) => {

  switch (action.type) {
    case GET_HOLIDAY_SUCCESS:
      return {
        ...state,
        holiday: action.payload,
      }

    case GET_HOLIDAY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_HOLIDAY_DETAILS_SUCCESS:
      return {
        ...state,
        holidayDetails: action.payload,
      }

    case GET_HOLIDAY_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_HOLIDAY_SUCCESS:
      return {
        ...state,
        holidayDetails: action.payload.data,
        addHoliday: action.payload,
      }

    case ADD_HOLIDAY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_HOLIDAY_SUCCESS:
      return {
        ...state,
        holidayDetails: action.payload.data,
        editHoliday: action.payload,
      }

    case UPDATE_HOLIDAY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_HOLIDAY_SUCCESS:
      return {
        ...state,
        delHoliday: action.payload,
      }

    case DELETE_HOLIDAY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case RESET_HOLIDAY_STATE:
      return {
        ...state,
        addHoliday: [],
        holidayDetails: [],
        editHoliday: [],
        delHoliday: [],
        actHoliday: [],
        deactHoliday: [],
        error:[],
      }
    default:
      return state
  }
}

export default Holiday
